import { render } from "./Reviews.vue?vue&type=template&id=2a326050"
import script from "./Reviews.vue?vue&type=script&lang=js"
export * from "./Reviews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Goya/components/Product/Reviews.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a326050"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a326050', __exports__)) {
    api.reload('2a326050', __exports__)
  }
  
  module.hot.accept("./Reviews.vue?vue&type=template&id=2a326050", () => {
    api.rerender('2a326050', render)
  })

}


export default __exports__